import React, { useState } from "react";
import { ITreatment, ISubTreatment } from "../types/clinic.types";
import { ConfirmationModal } from "./ConfirmationModal";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
interface Props {
  treatment: ITreatment;
  onDelete: () => void;
  onEdit: () => void;
  onAddSub: () => void;
  onEditSub: (sub: ISubTreatment) => void;
  onDeleteSub: (subId: string) => void;
}

export const TreatmentCard: React.FC<Props> = ({
  treatment,
  onDelete,
  onEdit,
  onAddSub,
  onEditSub,
  onDeleteSub,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [subDeleteCandidate, setSubDeleteCandidate] = useState<string | null>(
    null
  );

  const handleDeleteConfirm = () => {
    if (subDeleteCandidate) {
      onDeleteSub(subDeleteCandidate);
      setSubDeleteCandidate(null);
    }
  };

  return (
    <div className="treatment-card">
      <header
        className="treatment-header"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <h4>{treatment.name} - {treatment.description}</h4>
        <div className="actions">
          <button
            className="btn btn-icon"
            onClick={(e) => {
              e.stopPropagation();
              onEdit();
            }}
          >
            <EditIcon />
          </button>
          {/* <button
            className="btn btn-icon"
            onClick={(e) => {
              e.stopPropagation();
              onDelete();
            }}
          >
            <DeleteIcon />
          </button> */}
          {isExpanded ? <ExpandMoreIcon /> : <ExpandLessIcon />}
        </div>
      </header>

      {isExpanded && (
        <div className="treatment-body">
          <p>{treatment.description}</p>
          <div className="price-grid">
            <div className="price-item">
              <strong> Consulting Local Price:</strong> {treatment.localPrice}{" "}
              <strong>
                {" "}
                <i>LKR</i>
              </strong>
            </div>
            <div className="price-item">
              <strong>Consulting Foreigner Price:</strong>{" "}
              {treatment.foreginPrice}{" "}
              <strong>
                {" "}
                <i>USD</i>
              </strong>
            </div>
          </div>

          <div className="sub-treatments">
            <h5>Sub-Treatments</h5>
            {treatment.subTreatments.length === 0 ? (
              <p>No sub-treatments.</p>
            ) : (
              treatment.subTreatments.map((sub,i) => (
                <div key={i} className="sub-treatment-item">
                  <div className="sub-details">
                    <strong>{sub.description}</strong>
                    <span>
                      Local: {sub.localPrice} LKR min {sub.minlocalPrice} LKR - max{" "}
                      {sub.maxlocalPrice} LKR{" "}
                    </span>{" "}
                    <br />{" "}
                    <span>
                      {" "}
                      Foreigner: {sub.foreignerPrice} USD min{" "}
                      {sub.minforeignerPrice} USD - max {sub.maxforeignerPrice} USD
                    </span>
                    <br />
                    <span>Description: {sub.description}</span>
                    <br />
                    <span>Note: {sub.note}</span>
                  </div>
                  <div className="actions">
                    <button
                      className="btn btn-icon"
                      onClick={() => onEditSub(sub)}
                    >
                      <EditIcon />
                    </button>
                    <button
                      className="btn btn-icon"
                      onClick={() => setSubDeleteCandidate(sub?.id)}
                    >
                      <DeleteIcon />
                    </button>
                  </div>
                </div>
              ))
            )}
            <button
              className="btn btn-light"
              style={{ marginTop: "1rem" }}
              onClick={onAddSub}
            >
              <AddIcon /> Add Sub-Treatment
            </button>
          </div>
        </div>
      )}

      {subDeleteCandidate && (
        <ConfirmationModal
          title="Delete Sub-Treatment"
          message="Are you sure you want to delete this sub-treatment?"
          onConfirm={handleDeleteConfirm}
          onCancel={() => setSubDeleteCandidate(null)}
        />
      )}
    </div>
  );
};
